module.exports = __webpack_public_path__ + "static/media/leaderboard.962f72da.svg";